import React from 'react';
import PolicyDistributionContainer from "../containers/PolicyDistributionContainer";

const PolicyDistributionPage = () => {
    return (
        <>
            <PolicyDistributionContainer />
        </>
    );
};

export default PolicyDistributionPage;